import { Input as AntdMobileInput } from "antd-mobile";
import { BaseInputProps } from "./Input.types";
import "./Input.scss";

export const Input: React.FC<BaseInputProps> = ({
  variant = "primary",
  size = "md",
  value,
  defaultValue,
  placeholder,
  disabled = false,
  readOnly = false,
  clearable = false,
  clearIcon,
  onlyShowClearWhenFocus,
  onClear,
  onChange,
  onFocus,
  onBlur,
  onEnterPress,
  className = "",
  testId,
  ...props
}) => {
  const inputClass = [
    "input",
    `input--${variant}`,
    `input--${size}`,
    disabled && "input--disabled",
    readOnly && "input--readonly",
    clearable && "input--clearable",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <AntdMobileInput
      className={inputClass}
      value={value}
      defaultValue={defaultValue}
      placeholder={placeholder}
      disabled={disabled}
      readOnly={readOnly}
      clearable={clearable}
      clearIcon={clearIcon}
      onlyShowClearWhenFocus={onlyShowClearWhenFocus}
      onClear={onClear}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      onEnterPress={onEnterPress}
      data-testid={testId}
      {...props}
    />
  );
};

export default Input;
